export const iconFontAwesomeEnergyBatteryEmpty = (
	<i className="fa-solid fa-battery-empty"></i>
);
